// The journaling streak on Home: every day you traded, did you journal it? Days without trades
// don't count or break it, and today doesn't break it until it's over (it's "waiting"). Journaled
// means the End-of-day reflection was started: a score, a review or a ticked checklist item (the
// same test as the "Days in a row journaling" goal in Goals.js).
import { currentTradingDay, tradingDayKey } from './pnl';

export const journaledNote = (n) => Boolean(n && (n.score || (n.review && n.review.trim()) || (n.eveningDone && n.eveningDone.length)));

// { current, best, today: 'done' | 'waiting' | null, days } — `today` is null with no trades today.
export function journalStreak(trades, notes, today = currentTradingDay()) {
  const days = [...new Set(trades.map((t) => tradingDayKey(t.date)))].filter((d) => d <= today).sort();
  let run = 0;
  let best = 0;
  for (const d of days) {
    if (journaledNote(notes[d])) { run += 1; best = Math.max(best, run); } else if (d !== today) run = 0;
  }
  const tradedToday = days[days.length - 1] === today;
  return { current: run, best, today: tradedToday ? (journaledNote(notes[today]) ? 'done' : 'waiting') : null, days: days.length };
}
